module.exports = __webpack_public_path__ + "img/trash-p.4f49ea7d.svg";